import React from "react";

function Header() {
  return (
    <header style={{
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 25%, #667eea 50%, #764ba2 75%, #667eea 100%)",
      backgroundSize: "400% 400%",
      animation: "gradientShift 8s ease infinite",
      padding: "60px 20px",
      textAlign: "center",
      color: "#fff",
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 10px 40px rgba(102,126,234,0.3)"
    }}>
      {/* Floating shapes */}
      <div style={{
        position: "absolute",
        top: "20%",
        left: "10%",
        width: "60px",
        height: "60px",
        background: "rgba(255,255,255,0.1)",
        borderRadius: "50%",
        animation: "float 6s ease-in-out infinite"
      }}></div>
      <div style={{
        position: "absolute",
        top: "70%",
        right: "15%",
        width: "80px",
        height: "80px",
        background: "rgba(255,255,255,0.08)",
        borderRadius: "20px",
        animation: "float 8s ease-in-out infinite reverse"
      }}></div>
      
      {/* Main title */}
      <h1 style={{
        fontSize: "3.5rem",
        fontWeight: "900",
        margin: "0 0 10px 0",
        textShadow: "0 8px 20px rgba(0,0,0,0.3)",
        background: "linear-gradient(45deg, #fff, #ffd700)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        letterSpacing: "2px"
      }}>
        📅 Date Converter
      </h1>
      
      {/* Subtitle */}
      <p style={{
        fontSize: "1.4rem",
        margin: "0",
        opacity: "0.9",
        fontWeight: "500",
        textShadow: "0 2px 10px rgba(0,0,0,0.2)"
      }}>
        Convert dates between Nepali (BS) and English (AD) calendars
      </p>
      
      {/* Decorative line */}
      <div style={{
        width: "100px",
        height: "4px",
        background: "linear-gradient(90deg, #ffd700, #fff, #ffd700)",
        margin: "20px auto 0",
        borderRadius: "2px",
        animation: "shimmer 2s ease-in-out infinite alternate"
      }}></div>
      
      <style>
        {`
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        
        @keyframes shimmer {
          0% { opacity: 0.5; }
          100% { opacity: 1; }
        }
        `}
      </style>
    </header>
  );
}

export default Header;
